import { BoxProps } from '@jfs/ui-new'

const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: 35,
  } as BoxProps,
  tabsCenter: {
    backgroundColor: 'WHITE',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 7,
    borderColor: 'DISABLED_GREY',
    borderWidth: 1,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  } as BoxProps,
  modal: {
    position: 'absolute',
    elevation: 2,
    shadowOpacity: 1,
    opacity: 1,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    ...shadowStyle,
    zIndex: 1,
    borderWidth: 1,
    borderColor: 'GRAY_BORDER',
  } as BoxProps,
  overlayStyle: {
    backgroundColor: 'TRANSPARENT',
    width: '100%',
    height: '100%',
  } as BoxProps,
  dropdownStyle: {
    position: 'absolute',
    flex: 1,
    shadowColor: 'BLACK_LIGHT',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.3,
    shadowRadius: 10,
    elevation: 2,
    borderRadius: 12,
    backgroundColor: 'BLUE',
    borderColor: 'SECONDARY_GREY',
  } as BoxProps,
  dimens: {
    top: 36,
    right: 0,
  },
  row: {
    flexDirection: 'row',
    alignSelf: 'center',
  } as BoxProps,
}
